<template>
  <div id="app">
    
    <router-view  v-if="isActive"/>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isActive: true
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  methods: {
    reload () {
      this.isActive = false
      this.$nextTick(function () {
        this.isActive = true
      })
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
/deep/ .MLK__backdrop{
  z-index: 5010 !important;
}
/deep/ .MLK__plate{
  z-index: 5012 !important;
}
body > .ML__keyboard{
  z-index: 5010 !important;
}
body.ML__fonts-loading .ML__base {
    visibility: visible!important;
}

</style>
